import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import type { ShopStateType, ApiGetDataStatus } from '@redux/types'
import { SeasonProductType, ProductOptionType } from '@schemas'

// initial state
const initialState: ShopStateType = {
	triggerInitShopPage: false,
	triggerInitShopItemPage: false,

	seasonId: '',

	// product
	productListStatus: 'init',
	productList: [],

	shopItemStatus: 'init',

	// option
	getShopItemOption: '',
	optionList: [],
}

const slice = createSlice({
	name: 'shop',
	initialState,
	reducers: {
		TRIGGER_INIT_SHOP_PAGE: (state: ShopStateType, action: PayloadAction<boolean>) => {
			state.triggerInitShopPage = action.payload
		},
		SEASON_ID: (state: ShopStateType, action: PayloadAction<string>) => {
			state.seasonId = action.payload
		},
		TRIGGER_INIT_SHOP_ITEM_PAGE: (
			state: ShopStateType,
			action: PayloadAction<boolean>,
		) => {
			state.triggerInitShopItemPage = action.payload
		},

		// product
		PRODUCT_LIST_STATUS: (
			state: ShopStateType,
			action: PayloadAction<ApiGetDataStatus>,
		) => {
			state.productListStatus = action.payload
		},
		PRODUCT_LIST: (state: ShopStateType, action: PayloadAction<SeasonProductType[]>) => {
			state.productList = action.payload
		},

		SHOP_ITEM_STATUS: (state: ShopStateType, action: PayloadAction<ApiGetDataStatus>) => {
			state.shopItemStatus = action.payload
		},

		// option
		GET_SHOP_ITEM_OPTION: (state: ShopStateType, action: PayloadAction<string>) => {
			state.getShopItemOption = action.payload
		},
		OPTION_LIST: (state: ShopStateType, action: PayloadAction<ProductOptionType[]>) => {
			state.optionList = action.payload
		},
	},
})

export const shopActions = slice.actions
export default slice.reducer
